import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import BlogDetailPage from './BlogDetailPage';

export const prefix = 'bm-p-blog-detail';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: BlogDetailPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
